import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import SnsLinks from '~/src/feature/Ambassador/components/SnsLinks';

const Container = styled.div<{ theme: Theme }>`
  display: flex;
  padding: ${({ theme }) => theme.spacing(4, 2)};
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ theme }) => theme.spacing(4)}px;
    flex-direction: row;
    align-items: start;
  }
`;
const Img = styled.img<{ theme: Theme }>`
  border-radius: 4px;
  height: 100%;
  width: 150px;
  margin: ${({ theme }) => theme.spacing(0, 0, 3.5)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 200px;
    margin: ${({ theme }) => theme.spacing(0, 2.5, 0, 0)};
  }
`;
const Name = styled.h2<{ theme: Theme }>`
  font-weight: bold;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)}px;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: start;
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  }
`;
const Hometown = styled.p<{ theme: Theme }>`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  white-space: pre-wrap;
  margin-bottom: ${({ theme }) => theme.spacing(2.5)}px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: start;
  }
`;
const Introduction = styled.div<{ theme: Theme }>`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  white-space: pre-wrap;
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-bottom: ${({ theme }) => theme.spacing(4)}px;
  }
`;

interface Props {
  image: string;
  name: string;
  hometown: string;
  introduction: string;
  twitter?: string;
  instagram?: string;
  youtube?: string;
}

const Profile: VFC<Props> = ({
  image,
  name,
  hometown,
  introduction,
  twitter,
  instagram,
  youtube,
}) => {
  const theme = useTheme();
  return (
    <Container theme={theme}>
      <Img src={image} alt={name} theme={theme} />
      <div>
        <Name theme={theme}>{name}</Name>
        <Hometown theme={theme}>{hometown}</Hometown>
        <Introduction theme={theme}>{introduction}</Introduction>
        <SnsLinks twitter={twitter} instagram={instagram} youtube={youtube} />
      </div>
    </Container>
  );
};

export default Profile;
